<template>
  <div v-if="superAdmin">
      <v-dialog
        v-model="loading"
        persistent
        width="800"
        >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            Reversing<span v-if="customLogLead"> | Lead: {{customLogLead}}</span>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
            <v-layout row wrap>
              <v-flex xs4 v-for="k in pKeys" :key="k">
                <div>{{k}}</div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-layout wrap row justify-start  pa-4>
        <v-flex xs12>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Reverse Orders to last status By Key
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Agent"
										solo
										hide-details
										disabled
                    :loading="loading"
										v-model="userName"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Delimiter"
										solo
										disabled
										hide-details
                    :loading="loading"
										v-model="delimiter"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-textarea
										label="keys"
										v-model="pastedData"
										solo
									></v-textarea>
              	</v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							<v-btn @click="reverseOrdersAfterSearchByKey()" :loading="loading" color="success" dark>
                reverse
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>

import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import json2csv from 'json2csv'
import axios from 'axios';
import { productApiUrl, crmApiUrl } from '@/config/urls';
const headers = {
  'Accept': 'application/json'
}

export default {
  data(){
    return {
			loading: false,
			pastedData:null,
			delimiter:',',
      pKeys:[],
      customLogLead:null
    }
  },
  methods: {
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
    getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
      var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
    },
    exportData(data = this.exports, name){
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'log_export'
      link.setAttribute("download", `${n}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    async reverseOrdersAfterSearchByKey() {
			this.pKeys=[]
      this.fKeys=[]
      this.loading = true
      let statuses = await db.ref(`orderstatuses`).once('value').then(x=>x.val())
      let o = Object.values(statuses)
      let s = o.map(x=>x.name)
			let a = this.pastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>x.trim());
			(async () => {
				for (let i = 0; i < a.length; i++) {
					const order = a[i];
					if(order){
						let n = order
						try {
              let lead = await store.collection(`leads`).doc(n).get().then(x=>x.data())
              this.customLogLead = n
              let k = lead.status_timeline ? Object.keys(lead.status_timeline) : null
              if(k) {
                let lastcdate = lead.status_timeline ? Object.values(lead.status_timeline).map((x, i) => {
                  return {
                    ...x,
                    key: k[i]
                  }
                })
                .sort((a, b) => {
                  return new Date(a.date).getTime() - new Date(b.date).getTime()
                }) : null

                lastcdate.pop()
                if(lastcdate.length) {
                  let ns = s.filter(x=> x.toLowerCase().split(' ').join('_') == lastcdate[lastcdate.length-1].key)[0]
                  console.log(lastcdate)
                  console.log(lastcdate[lastcdate.length-1].key)
                  console.log(ns);
                  lead.status_timeline = {}
                  lead.order_status = ns
                  for (let ss = 0; ss < lastcdate.length; ss++) {
                    const st = lastcdate[ss];
                    if(!lead.status_timeline[st.key]) {
                      lead.status_timeline[st.key] = {}
                    }
                    lead.status_timeline[st.key]['date'] = st.date
                    lead.status_timeline[st.key]['agent'] = st.agent
                  }
                } else {
                  lead.order_status = 'NEW'
                  lead.status_timeline = {}
                }
              } else {
                lead.order_status = 'NEW'
                lead.status_timeline = {}
              }
              console.log('--------------updated lead----------');
              console.log(lead);
              console.log('------------------------------------');
              await store.collection(`leads`).doc(n).update(lead)
							try {
								lead.key = n
              	await axios.post(productApiUrl('leads'), lead, {headers}).then(x=>x.data)
								if(lead.ninja) {
									let pu = await axios.post(crmApiUrl(`crmleads/${lead.id}`), lead, {headers}).then(x=>x.data).catch(async (error)=> console.log('NINJA ERROR ', error))
								}
							} catch (error) {
								console.log('lead sync error', error)
							}
						  this.pKeys.push(order)
						} catch (error) {
							this.fKeys.push(order)
						}
						console.log(order)
					}
        }
        this.exportData(this.pKeys, 'reversed')
        this.customLogLead = null
        this.loading = false
				console.log('failed keys', this.fKeys)
			})()
		}
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
		}
  },
  computed:{
    
  },
  async created(){
		// let a = await db.ref(`users`).once('value').then(x=>x.val())
		// let u = Object.values(a);
		// (async ()=>{
		// 	for (let i = 0; i < u.length; i++) {
		// 		const user = u[i];
		// 		await db.ref(`users/${user.user_id}`).update({access:true})
		// 		console.log(user)
		// 	}
		// 	let b = await db.ref(`users`).once('value').then(x=>x.val())
		// 	console.log(b)
		// })()
		// let a = await db.ref(`formbuilder`).once('value').then(x=>x.val())
		// let b = Object.values(a)
		// let c = b.filter(x=>x.fid == '5185307')
		// let e = b.filter(x=>{
		// 	for (const key in x) {
		// 		if (x.hasOwnProperty(key)) {
		// 			const val = x[key];
		// 			if(val.includes('568555066')) {
		// 				return x
		// 			}
		// 		}
		// 	}
		// })
		// console.log(b.length)
		// console.log(e);
		// (async ()=>{
		// 	let gg =0 
		// 	for (let i = 0; i < b.length; i++) {
		// 		const entry = b[i];
		// 		let entry_id = entry.entry_id + '-' + entry.fid
		// 		let m = await db.ref('leads').orderByChild(`entry_id`).equalTo(entry_id).once('value').then(x => x.val())
		// 		if(!m){
		// 			console.log(entry_id)
		// 			gg++
		// 		}
		// 	}
		// 	console.log(gg)
		// 	console.log(b.length)
		// })()

		
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
